module.exports = __webpack_public_path__ + "static/dictionary-charts-0c84b932d7bc725db69b1f9e1b8fa0ec.png";